import Validator from './validator.js';

export default class RecaptchaValidator extends Validator {
    constructor(input) {
        super(input);        
    }

    valid() {
        const widgetId = this.input.parent.widgetId;
        return Promise.resolve(window.grecaptcha.getResponse(widgetId) !== '');       
    }

    static applies(input) {
        return input.el.dataset.recaptcha !== undefined;
    }
}
